require('../common/custom/navbar.js');

function validar_email(email){

    var regex = /[\w-\.]{2,}@([\w-]{2,}\.)*([\w-]{2,}\.)[\w-]{2,4}/;

    if(regex.test(email)){
        return true;
    }else{
        return false;
    }

};

//Scroll spy smooth animation

// Add scrollspy to <body>

$(document).ready(function() {

    //Newsletter en el footer (actualmente en desuso)
    // $('#btn-newsletter').click(function() {

    //     if($('#inputEmail').val() == '' || !validar_email($('#inputEmail').val()) || !$('input[name=privacityCheckLetter]').is(':checked')){

    //         $('#modalErrorNewsletter').modal('show');

    //     }else{

    //         $('.cl-loading-news').show();

    //         $.ajaxSetup({
    //             headers: {
    //               'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    //             }
    //         });

    //         $.ajax({
    //             type:'POST',
    //             url: APP_URL+'/ajax/subscribeNewsletter',
    //             data: {
    //                 email: $('#inputEmail').val(),
    //                 idioma: $('html').attr('lang')
    //             },
    //             success: function(data){

    //                 if(data == 1){
    //                     $('#inputEmail').val('');
    //                     $('input[name=privacityCheckLetter]').prop("checked", false);
    //                     $('.cl-loading-news').hide();
    //                     $('#modalEnviadaNewsletter').modal('show');
    //                 }else{
    //                     $('.cl-loading-news').hide();
    //                     $('#modalErrorEnvioNews').modal('show');
    //                 }

    //             }
    //         });

    //     }

    // });

    //Por defecto marcamos la opción 1
    //$('input[name="opt_radio_search"]').filter('[data-value=1]').prop('checked', true);


    //Mostrar/Ocultar servicios
    $('span[data-name="serviceCollapse"]').click(function() {
        var target = $(this).attr("data-target");
        var label = $(this).find("label");
        var arrowUp = $(this).find("span[data-name='arrowUp']");
        var arrowDown = $(this).find("span[data-name='arrowDown']");


        $(target).on('hide.bs.collapse', function () {
            label.text(translations.showServices);

            arrowUp.removeClass("d-inline");
            arrowUp.addClass("d-none");

            arrowDown.removeClass("d-none");
            arrowDown.addClass("d-inline");
        });

        $(target).on('show.bs.collapse', function () {
            label.text(translations.hideServices);

            arrowDown.removeClass("d-inline");
            arrowDown.addClass("d-none");

            arrowUp.addClass("d-inline");
            arrowUp.removeClass("d-none");
        });
    });

    $('.dragscroll li').click(function(event) {
        if ($(this).closest('.dragscroll').hasClass('dragging')) {
          event.preventDefault();
          return false;
        }
    });

    //Al marcar transporte aparece un campo oculto
    $('#transportCheck').click(function() {
        if($(this).prop("checked") == true){
            $('#inputTransport').addClass("d-block");
            $('#inputTransport').removeClass("d-none");
        } else if($(this).prop("checked") == false){
            $('#inputTransport').removeClass("d-block");
            $('#inputTransport').addClass("d-none");
        }
    });

    if($('#transportCheck').prop("checked") == true) {
        $('#inputTransport').addClass("d-block");
        $('#inputTransport').removeClass("d-none");
    } else if($('#transportCheck').prop("checked") == false){
        $('#inputTransport').removeClass("d-block");
        $('#inputTransport').addClass("d-none");
    }

    //Al pulsar el boton colocamos su texto en comentarios
    $('a[name="placeOffer"]').click(function() {
        var title = $(this).attr("data-title");
        $("#comment").val($("#comment").val() + title+"\n");
    });


    //MENÚ MÓVIL
    mostrar_menu(0);

});

$(document).ready(function() {

    //-- Contacto --//

    $("select[name='selectMessage']").change(function() {
        checkContactForms($(this).val());
    });

    $("#pills-yes-tab").click(function(){
        $("input[name='mailConReserva']").val('yes');
    });

    $("#pills-no-tab").click(function(){
        $("input[name='mailConReserva']").val('no');
    });

    $(".form-is-invalid").change(function() {
        $(this).removeClass('form-is-invalid');
    });

    $("#privacityCheck").change(function() {
        $("label[for='privacityCheck']").removeClass('check-is-invalid');
    });

    //-- FIN - Contacto --//

});
